import { useMemo } from 'react';

import { addUuid } from 'helpers';

export const useCivility = (inputName = 'civility') => {
  const civilityOptions = useMemo(() => {
    return addUuid(
      [
        {
          name: inputName,
          value: 'Mr',
          label: 'form:civility.mister'
        },
        {
          name: inputName,
          value: 'Mme',
          label: 'form:civility.lady'
        }
      ],
      'civility-radio-'
    );
  }, [inputName]);

  return { civilityOptions };
};
